import { IBlockTimeItem } from 'src/app/ReusableComponent/block-time-report/block-time-report.model';

/**
 * Creates the empty draft of a manually added record, with the shape of the legacy add form.
 */
export function createEmptyBlockTimeRecord(): IBlockTimeItem {
  return {
    blockTimeReportID: null,
    srCreatedOnDate: null,
    tripID: null,
    customer: null,
    serviceType: null,
    primaryOrgan: null,
    additionalOrgans: null,
    plannedStartTime: null,
    plannedEndTime: null,
    ActualStartTime: null,
    ActualEndTime: null,
    unosid: null,
    region: null,
    airVendor: null,
    outboundReposition: null,
    inboundReposition: null,
    routing: null,
    tailNumber: null,
    groundVendor: null,
    aircraftType: null,
    aircraftSize: null,
    cost: null,
    profit: null,
    rate: null,
    flightMargin: null,
    invoiceID: null,
    ar: false,
    ap: false,
    note: null,
    lastUpdatedOn: null,
    LastUpdatedBy: null,
    isRecordManuallyAdded: true,
    isRecordSplitted: false,
    monthYear: '',
    isCancelledNoCost: false,
    isCompleted: false,
    withMovement: false,
    liveFlightHours: null,
    obEstimatedBlockHours: null,
    ibEstimatedBlockHours: null,
    cancellationHours: null,
    actualBlockTime: null,
    estimatedBlockHours: null,
    totalBilledHours: null,
    actualInBoundReposition: null,
    ibRepoVerificationReason: null,
    ibRepoNeedsVerification: false,
    ibRepoAwaitingVerification: false,
  };
}
